// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  #myTooltip {
    position: absolute;
    text-align: left;
    width: 80px;
    height: auto;
    min-height: 20px;
    font: 12px sans-serif;
    background-color: rgb(255, 255, 255);
    border: 2px solid rgb(100, 161, 209);
    color: #5E99BD;
    border-radius: 8px 8px 8px 8px;
    pointer-events: none;
    padding: 11px;
   }

   #myTooltip:before {
    box-sizing: border-box;
    display: inline;
    font-size: 18px;
    width: 100%;
    line-height: 1;
    color: rgb(100, 161, 209);
    content: "\\25BC";
    position: absolute;
    text-align: center;
    top: 100%;
    left: -2px;
}

.tooltip-dashboards {
    position: absolute;
    color: white;
    text-align: center;
    width: auto;
    height: auto;
    padding: 10px;
    font-weight: 500;
    font: 10px sans-serif;
    background: black;
    border: 0px;
    border-radius: 4px;
    pointer-events: none;
    opacity: 0;
    z-index: 99999999999999 !important;
  }

  .axis--x .tick line,
.axis--y .tick line {
    stroke: lightgrey;
    stroke-opacity: 0.2; /* Adjust this value to make the lines lighter */
    shape-rendering: crispEdges;
}

.axis--x path,
.axis--y path {
    display: none;
}

.custom-multiselect-filter .rmsc .dropdown-container {
  width: 460px;
  height: 39px;
  box-sizing: border-box;
  border: 2px solid #E3E9F4 !important;
  border-radius: 12px !important;
  font-weight: 500;
}

.select-custom-input-dashboard {
  padding: 10px;
  box-sizing: border-box;
  border: 2px solid #E3E9F4;
  border-radius: 12px;
  max-width: 80%; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}



.lightTheme input[type=checkbox] {
  width: 18px !important;
  height: 18px !important;
  margin-right: 15px !important;
  margin-top: 5px !important;
  -o-appearance: none !important;
  appearance: none !important;
  box-shadow: none !important;
  font-size: 0.8em !important;
  text-align: center !important;
  line-height: 1.2em !important;
  background: var(--foundation-neutral-neutral-100, #F4F7FB) !important;
  border: 2px solid black !important;
  display: inline-block !important;
  vertical-align: middle !important;
  position: relative !important;
  cursor: pointer !important;
}

.lightTheme input[type=checkbox]:checked {
  background: var(--primary) !important;
  border: 2px solid var(--secondary-700) !important;
}

.lightTheme input[type=checkbox]:checked:after {
  content: "" !important;
  position: absolute !important;
  top: 0px !important;
  left: 4px !important;
  width: 6px !important;
  height: 12px !important;
  border: solid black !important;
  border-width: 0 2px 2px 0 !important;
  transform: rotate(45deg) !important;
}

/* Align checkboxes and options */
.rmsc input[type=checkbox] {
  width: 18px !important;
  height: 18px !important;
  margin-right: 8px !important; /* Adjust margin as needed */
  margin-top: 0px !important;
  position: relative;
  top: 0px; /* Adjust top positioning */
  vertical-align: middle;
}

/* Style for the label containing the checkbox and text */
.rmsc label {
  display: flex;
  align-items: center;
  font-size: 0.8rem; /* Reduce font size */
}

.rmsc .search input {
  font-size: 0.9em !important;
}

.rmsc .item-renderer {
  display: block !important;
  /* align-items: baseline; */
}

.rmsc.custom-multiselect-branch.rmsc .dropdown-container {
  width: 315px !important;
  height: 39px;
  box-sizing: border-box;
  border: 2px solid #E3E9F4 !important;
  border-radius: 12px !important;
  font-weight: 500;
}

  .y-axis-grid line {
    stroke: lightgray;
    stroke-opacity: 0.7;
    stroke-width: 1px; /* Adjust the thickness as needed */
  }

  /* .pin-btn :hover {
    color: black;
    transform: rotate(60deg);
  } */

  .pin-btn{
    margin-left: 5px;
    transition: transform 0.3s ease-in-out;
  }
  
  
  div#layout {
    text-align: center;
  }
  
  div#container {
    width: 1000px;
    height: 600px;
    margin: auto;
    background-color: #2F4A6D;
  }

  .filter-dropdown .select__menu{
    position: relative !important;
  }

  .filter-dropdown-single-select .select__menu{
    position: absolute !important;
  }

  .filter-dropdown-single-select div.select__menu div.select__option:not(.select__option--is-selected){
    padding-left: 15px;
    font-size: 0.8rem;
  }

  .filter-dropdown-single-select  div.select__menu div.select__option.select__option--is-selected{
    background-color: #f1f3f5 !important;
    border-radius: 0px !important;
    font-size: 0.8rem;
  }

  .filter-dropdown-single-select div.select__placeholder {
    color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32)) !important;
  }

  .filter-dropdown-single-select div.select__control {
    height: 39px; 
    box-sizing: border-box; 
    border: 2px solid #E3E9F4 !important; 
    border-radius: 12px !important; 
    font-weight: 500;
}

  .filter-dropdown-single-select div.select__menu div.select__option:not(.select__option--is-selected):hover{
    background-color: #f1f3f5 !important;
    border-radius: 0px !important;
  }

  .filter-dropdown-single-select div.select__menu, div.select_multi__menu{
    border-radius: 0px;
    top: 50px;
    padding: 2px !important;
  }

  #legend-container {
    max-height: 30px; /* Adjust the height as needed */
    overflow-y: auto;
    white-space: nowrap;
}

  .chart-heading{
    font-size: 22px;
    font-weight: 550;
    text-align: center;
  }
  
  .dashboard-heading{
    font-size: 30px;
    font-weight: 600;
  }

  .chart-title{
    padding:  0.9375rem;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    border-top-left-radius: 15px; 
    border-top-right-radius: 15px; 
  }

  .no-chart-title {
    padding: 0.9375rem;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    height: 56px; 
  }
  
  /* .bar {
    fill: #1A73E8;
  }
   */
  text {
    font-size: 10px;
    fill: black;
  }

  .x-axis-label{
    font-size: 11px;
    fill: black;
    font-weight: 600 !important;
    font-family: Roboto !important;
  }

  .y-axis-label{
    font-size: 11px;
    fill: black;
    font-weight: 600 !important;
    font-family: Roboto !important;
  }
  
  /* path {
    stroke: gray;
  } */
  
  line#limit {
    stroke: #FED966;
    stroke-width: 3;
    stroke-dasharray: 3 6;
  }
  
  /* .grid path {
    stroke-width: 0;
  } */
  
  .grid .tick line {
    stroke: #9FAAAE;
    stroke-opacity: 0.01;
  }
  
  text.divergence {
    font-size: 14px;
    fill: #2F4A6D;
  }
  
  text.value {
    font-size: 14px;
  }
  
  text.title {
    font-size: 22px;
    font-weight: 600;
  }
  
  text.label {
    font-size: 14px;
    font-weight: 400;
  }
  
  text.source {
    font-size: 10px;
  }

  .react-flow__controls button[aria-label="fit view"]{display: none;}

  .filter-menu {
    max-height: 300px;
    overflow-y: auto;
    font-size: 12px;
    padding:5px;
    min-width: max-content;
    right: 0;
    text-align: left;
  }

  .filter-menu ul li input[type=checkbox] {
    margin-top: 0 !important;
    margin-right: 5px !important;
  }

  .address-checker #map, .address-checker #uploadmap { height: 500px; margin: 0; }
  .address-checker #autocompleteResults, .address-checker #results {
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1001;
    width: 250px;
    background: white;
    border: 1px solid #ccc;
    border-top: none;
    max-height: 200px;
    overflow-y: auto;
    font-size: 14px;
    display: none;
  }
  .address-checker #autocompleteResults div {
    padding: 6px 10px;
    cursor: pointer;
  }
  .address-checker #autocompleteResults div:hover {
    background-color: #f0f0f0;
  }

  .address-checker #controls {
    font-size: 15px;
  }
  .address-checker #results {
    text-align: left;
    display: block;
    top: 30px;
    width: 100%;
    padding: 0 5px 5px 5px;
  }
  .address-checker #csvUpload { display: block; }
  /* address checker - end */`, "",{"version":3,"sources":["webpack://./src/kz-dashboards/css/style.css"],"names":[],"mappings":";;EAEE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAEhB,qBAAqB;IACrB,oCAAoC;IACpC,oCAAoC;IACpC,cAAc;IACd,8BAA8B;IAC9B,oBAAoB;IACpB,aAAa;GACd;;GAEA;IACC,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,kCAAkC;EACpC;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB,EAAE,gDAAgD;IACrE,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;;;AAIA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,qEAAqE;EACrE,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B,EAAE,4BAA4B;EAC1D,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ,EAAE,2BAA2B;EACrC,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;EAEE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB,EAAE,mCAAmC;EACxD;;EAEA;;;KAGG;;EAEH;IACE,gBAAgB;IAChB,sCAAsC;EACxC;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,oCAAoC;IACpC,8BAA8B;IAC9B,gBAAgB;AACpB;;EAEE;IACE,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,gBAAgB,EAAE,gCAAgC;IAClD,gBAAgB;IAChB,mBAAmB;AACvB;;EAEE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;;;IAGE;EACF;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;EACvB;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,oDAAoD,aAAa,CAAC;;EAElE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA,qDAAqD,aAAa,EAAE,SAAS,EAAE;EAC/E;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,WAAW;IACX,sBAAsB;EACxB;EACA,8BAA8B,cAAc,EAAE;EAC9C,0BAA0B","sourcesContent":["\n  \n  #myTooltip {\n    position: absolute;\n    text-align: left;\n    width: 80px;\n    height: auto;\n    min-height: 20px;\n    padding: 2px;\n    font: 12px sans-serif;\n    background-color: rgb(255, 255, 255);\n    border: 2px solid rgb(100, 161, 209);\n    color: #5E99BD;\n    border-radius: 8px 8px 8px 8px;\n    pointer-events: none;\n    padding: 11px;\n   }\n\n   #myTooltip:before {\n    box-sizing: border-box;\n    display: inline;\n    font-size: 18px;\n    width: 100%;\n    line-height: 1;\n    color: rgb(100, 161, 209);\n    content: \"\\25BC\";\n    position: absolute;\n    text-align: center;\n    top: 100%;\n    left: -2px;\n}\n\n.tooltip-dashboards {\n    position: absolute;\n    color: white;\n    text-align: center;\n    width: auto;\n    height: auto;\n    padding: 10px;\n    font-weight: 500;\n    font: 10px sans-serif;\n    background: black;\n    border: 0px;\n    border-radius: 4px;\n    pointer-events: none;\n    opacity: 0;\n    z-index: 99999999999999 !important;\n  }\n\n  .axis--x .tick line,\n.axis--y .tick line {\n    stroke: lightgrey;\n    stroke-opacity: 0.2; /* Adjust this value to make the lines lighter */\n    shape-rendering: crispEdges;\n}\n\n.axis--x path,\n.axis--y path {\n    display: none;\n}\n\n.custom-multiselect-filter .rmsc .dropdown-container {\n  width: 460px;\n  height: 39px;\n  box-sizing: border-box;\n  border: 2px solid #E3E9F4 !important;\n  border-radius: 12px !important;\n  font-weight: 500;\n}\n\n.select-custom-input-dashboard {\n  padding: 10px;\n  box-sizing: border-box;\n  border: 2px solid #E3E9F4;\n  border-radius: 12px;\n  max-width: 80%; \n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; \n}\n\n\n\n.lightTheme input[type=checkbox] {\n  width: 18px !important;\n  height: 18px !important;\n  margin-right: 15px !important;\n  margin-top: 5px !important;\n  -o-appearance: none !important;\n  appearance: none !important;\n  box-shadow: none !important;\n  font-size: 0.8em !important;\n  text-align: center !important;\n  line-height: 1.2em !important;\n  background: var(--foundation-neutral-neutral-100, #F4F7FB) !important;\n  border: 2px solid black !important;\n  display: inline-block !important;\n  vertical-align: middle !important;\n  position: relative !important;\n  cursor: pointer !important;\n}\n\n.lightTheme input[type=checkbox]:checked {\n  background: var(--primary) !important;\n  border: 2px solid var(--secondary-700) !important;\n}\n\n.lightTheme input[type=checkbox]:checked:after {\n  content: \"\" !important;\n  position: absolute !important;\n  top: 0px !important;\n  left: 4px !important;\n  width: 6px !important;\n  height: 12px !important;\n  border: solid black !important;\n  border-width: 0 2px 2px 0 !important;\n  transform: rotate(45deg) !important;\n}\n\n/* Align checkboxes and options */\n.rmsc input[type=checkbox] {\n  width: 18px !important;\n  height: 18px !important;\n  margin-right: 8px !important; /* Adjust margin as needed */\n  margin-top: 0px !important;\n  position: relative;\n  top: 0px; /* Adjust top positioning */\n  vertical-align: middle;\n}\n\n/* Style for the label containing the checkbox and text */\n.rmsc label {\n  display: flex;\n  align-items: center;\n  font-size: 0.8rem; /* Reduce font size */\n}\n\n.rmsc .search input {\n  font-size: 0.9em !important;\n}\n\n.rmsc .item-renderer {\n  display: block !important;\n  /* align-items: baseline; */\n}\n\n.rmsc.custom-multiselect-branch.rmsc .dropdown-container {\n  width: 315px !important;\n  height: 39px;\n  box-sizing: border-box;\n  border: 2px solid #E3E9F4 !important;\n  border-radius: 12px !important;\n  font-weight: 500;\n}\n\n  .y-axis-grid line {\n    stroke: lightgray;\n    stroke-opacity: 0.7;\n    stroke-width: 1px; /* Adjust the thickness as needed */\n  }\n\n  /* .pin-btn :hover {\n    color: black;\n    transform: rotate(60deg);\n  } */\n\n  .pin-btn{\n    margin-left: 5px;\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  \n  div#layout {\n    text-align: center;\n  }\n  \n  div#container {\n    width: 1000px;\n    height: 600px;\n    margin: auto;\n    background-color: #2F4A6D;\n  }\n\n  .filter-dropdown .select__menu{\n    position: relative !important;\n  }\n\n  .filter-dropdown-single-select .select__menu{\n    position: absolute !important;\n  }\n\n  .filter-dropdown-single-select div.select__menu div.select__option:not(.select__option--is-selected){\n    padding-left: 15px;\n    font-size: 0.8rem;\n  }\n\n  .filter-dropdown-single-select  div.select__menu div.select__option.select__option--is-selected{\n    background-color: #f1f3f5 !important;\n    border-radius: 0px !important;\n    font-size: 0.8rem;\n  }\n\n  .filter-dropdown-single-select div.select__placeholder {\n    color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32)) !important;\n  }\n\n  .filter-dropdown-single-select div.select__control {\n    height: 39px; \n    box-sizing: border-box; \n    border: 2px solid #E3E9F4 !important; \n    border-radius: 12px !important; \n    font-weight: 500;\n}\n\n  .filter-dropdown-single-select div.select__menu div.select__option:not(.select__option--is-selected):hover{\n    background-color: #f1f3f5 !important;\n    border-radius: 0px !important;\n  }\n\n  .filter-dropdown-single-select div.select__menu, div.select_multi__menu{\n    border-radius: 0px;\n    top: 50px;\n    padding: 2px !important;\n  }\n\n  #legend-container {\n    max-height: 30px; /* Adjust the height as needed */\n    overflow-y: auto;\n    white-space: nowrap;\n}\n\n  .chart-heading{\n    font-size: 22px;\n    font-weight: 550;\n    text-align: center;\n  }\n  \n  .dashboard-heading{\n    font-size: 30px;\n    font-weight: 600;\n  }\n\n  .chart-title{\n    padding:  0.9375rem;\n    font-size: 18px;\n    font-weight: 500;\n    text-align: left;\n    border-top-left-radius: 15px; \n    border-top-right-radius: 15px; \n  }\n\n  .no-chart-title {\n    padding: 0.9375rem;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n    height: 56px; \n  }\n  \n  /* .bar {\n    fill: #1A73E8;\n  }\n   */\n  text {\n    font-size: 10px;\n    fill: black;\n  }\n\n  .x-axis-label{\n    font-size: 11px;\n    fill: black;\n    font-weight: 600 !important;\n    font-family: Roboto !important;\n  }\n\n  .y-axis-label{\n    font-size: 11px;\n    fill: black;\n    font-weight: 600 !important;\n    font-family: Roboto !important;\n  }\n  \n  /* path {\n    stroke: gray;\n  } */\n  \n  line#limit {\n    stroke: #FED966;\n    stroke-width: 3;\n    stroke-dasharray: 3 6;\n  }\n  \n  /* .grid path {\n    stroke-width: 0;\n  } */\n  \n  .grid .tick line {\n    stroke: #9FAAAE;\n    stroke-opacity: 0.01;\n  }\n  \n  text.divergence {\n    font-size: 14px;\n    fill: #2F4A6D;\n  }\n  \n  text.value {\n    font-size: 14px;\n  }\n  \n  text.title {\n    font-size: 22px;\n    font-weight: 600;\n  }\n  \n  text.label {\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  text.source {\n    font-size: 10px;\n  }\n\n  .react-flow__controls button[aria-label=\"fit view\"]{display: none;}\n\n  .filter-menu {\n    max-height: 300px;\n    overflow-y: auto;\n    font-size: 12px;\n    padding:5px;\n    min-width: max-content;\n    right: 0;\n    text-align: left;\n  }\n\n  .filter-menu ul li input[type=checkbox] {\n    margin-top: 0 !important;\n    margin-right: 5px !important;\n  }\n\n  .address-checker #map, .address-checker #uploadmap { height: 500px; margin: 0; }\n  .address-checker #autocompleteResults, .address-checker #results {\n    position: absolute;\n    top: 48px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1001;\n    width: 250px;\n    background: white;\n    border: 1px solid #ccc;\n    border-top: none;\n    max-height: 200px;\n    overflow-y: auto;\n    font-size: 14px;\n    display: none;\n  }\n  .address-checker #autocompleteResults div {\n    padding: 6px 10px;\n    cursor: pointer;\n  }\n  .address-checker #autocompleteResults div:hover {\n    background-color: #f0f0f0;\n  }\n\n  .address-checker #controls {\n    font-size: 15px;\n  }\n  .address-checker #results {\n    text-align: left;\n    display: block;\n    top: 30px;\n    width: 100%;\n    padding: 0 5px 5px 5px;\n  }\n  .address-checker #csvUpload { display: block; }\n  /* address checker - end */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
